module.exports = "/static/assets/802d49285fc44414f08354b2fa5544cf.png";